import React from 'react'
import ReactTooltip from 'react-tooltip'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { ArrowLeft, Info } from '@phosphor-icons/react'

const Navbar = ({ onBack = () => {}, onSubmit = () => {}, disabled, isEdit, isPreview }) => {
  const { t } = useTranslation(['internal-inspections', 'common'])
  return (
    <div className="inspections-top-navbar">
      <div className="header-buttons">
        <button onClick={onBack} className="button button-lightgray">
          <ArrowLeft />
          {isPreview
            ? t('internal-inspections:templateNavbar.backToTemplates')
            : t('common:actions.back')}
        </button>
        {isPreview ? (
          <React.Fragment>
            <div className="header">{t('internal-inspections:templateNavbar.viewTemplate')}</div>
            <Info data-tip data-for="view-template" size={20} />
            <ReactTooltip className="tooltip" id="view-template" place="top" effect="solid">
              <div>{t('internal-inspections:templateNavbar.modifyOnTemplatesPage')}</div>
            </ReactTooltip>
          </React.Fragment>
        ) : (
          <div className="header">
            {isEdit
              ? t('internal-inspections:templateNavbar.editTemplate')
              : t('internal-inspections:templateNavbar.createTemplate')}
          </div>
        )}
      </div>
      {!isPreview ? (
        <div className="header-buttons">
          <button onClick={onSubmit} disabled={disabled} className="button button-black">
            {isEdit
              ? t('common:actions.save')
              : t('internal-inspections:templateNavbar.saveTemplate')}
          </button>
        </div>
      ) : null}
    </div>
  )
}

Navbar.propTypes = {
  onBack: PropTypes.func,
  onSubmit: PropTypes.func,
  isEdit: PropTypes.bool,
  isPreview: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default Navbar
